// extracted by mini-css-extract-plugin
export default {"itemWrapper":"ItemContainer_itemWrapper__UnFoc","title":"ItemContainer_title__DXkjV","itemContainer":"ItemContainer_itemContainer__02i-b","centered":"ItemContainer_centered__UCfdi"};